import useSWR from 'swr'

import { MutationOptions, useCallMutation } from '@/common/api/client'
import {
  GetW2SendStatusResponse,
  GetW2SendStatusVars,
  ListTargetListItemsResponse,
  ListTargetListItemsVars,
  ListTargetListsResponse,
  ListTargetListsVars,
  SendBulkVars,
  SendOneVars,
  SendResultResponse,
  W2IntegrationApiPath
} from '@/common/api/params/w2Integration'

export const useTargetListsGetApi = (vars: ListTargetListsVars | undefined) => {
  return useSWR<ListTargetListsResponse, Response, [string, ListTargetListsVars] | undefined>(
    vars ? [W2IntegrationApiPath.LIST_TARGET_LISTS, vars] : undefined
  )
}

export const useTargetListItemsGetApi = (vars: ListTargetListItemsVars | undefined) => {
  return useSWR<
    ListTargetListItemsResponse,
    Response,
    [string, ListTargetListItemsVars] | undefined
  >(vars ? [W2IntegrationApiPath.LIST_TARGET_LIST_ITEMS, vars] : undefined)
}

export const useW2SendStatusGetApi = (vars: GetW2SendStatusVars | undefined) => {
  return useSWR<GetW2SendStatusResponse, Response, [string, GetW2SendStatusVars] | undefined>(
    vars ? [W2IntegrationApiPath.W2_SEND_STATUS, vars] : undefined
  )
}

export const useSendOneApi = (options?: MutationOptions<SendResultResponse>) => {
  return useCallMutation<SendResultResponse, SendOneVars>(W2IntegrationApiPath.SEND_ONE, options)
}

export const useSendBulkApi = (options?: MutationOptions<SendResultResponse>) => {
  return useCallMutation<SendResultResponse, SendBulkVars>(W2IntegrationApiPath.SEND_BULK, options)
}
